import { EventEmitter, Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class PaymentEventsService {
  public paymentCancelled = new EventEmitter<boolean>();

  public notifyPaymentCancelled(): void {
    this.paymentCancelled.emit(true);
  }
}
